module.exports = __webpack_public_path__ + "img/forward.f1c357eb.svg";